export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/index.js